import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import { rupiah } from "@/lib/api";

const pct = (now, before) => (before ? Math.round(((now - before) / before) * 1000) / 10 : null);

const Delta = ({ label, now, before, money, testid }) => {
  const p = pct(now, before);
  const up = (p !== null && p > 0) || (p === null && now > 0);
  const down = p !== null && p < 0;
  const Icon = up ? TrendingUp : down ? TrendingDown : Minus;
  const color = up ? "text-emerald-700 bg-emerald-50" : down ? "text-red-700 bg-red-50" : "text-muted2 bg-sage-100";
  return (
    <div className="flex items-center justify-between py-1" data-testid={testid}>
      <span className="text-muted2">{label} <span className="text-xs">({money ? rupiah(before) : before})</span></span>
      <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${color}`}>
        <Icon className="w-3.5 h-3.5" />{p === null ? (now ? "Baru" : "0%") : `${p > 0 ? "+" : ""}${p.toLocaleString("id-ID")}%`}
      </span>
    </div>
  );
};

export const MonthCompare = ({ s }) => (
  <div className="mt-3 pt-3 border-t border-sage-200" data-testid={`compare-${s.outlet_code}`}>
    <div className="text-xs font-semibold text-forest mb-1">Dibanding bulan lalu ({s.prev.month})</div>
    <Delta label="Penjualan" now={s.total} before={s.prev.total} money testid={`compare-total-${s.outlet_code}`} />
    <Delta label="Pesanan lunas" now={s.orders_paid} before={s.prev.orders_paid} testid={`compare-orders-${s.outlet_code}`} />
    <Delta label="PB1" now={s.tax} before={s.prev.tax} money testid={`compare-tax-${s.outlet_code}`} />
  </div>
);

export const ItemRanking = ({ outlets, field = "top_items", title = "10 menu terlaris per gerai", testid = "top-items", slow = false }) => (
  <div className="mt-6" data-testid={testid}>
    <h3 className="font-serif font-semibold text-xl mb-1">{title}</h3>
    {slow && <p className="text-sm text-muted2 mb-3">Menu aktif dengan penjualan paling sedikit bulan ini (di luar 10 terlaris), termasuk yang belum terjual. Kandidat promo atau dihapus dari menu.</p>}
    <div className={`grid md:grid-cols-2 gap-4 ${slow ? "" : "mt-2"}`}>
      {outlets.map((s) => (
        <div key={s.outlet_code} className="card-paper p-5" data-testid={`${testid}-${s.outlet_code}`}>
          <div className="font-semibold mb-2">{s.outlet_code} · Gerai {s.outlet_name}</div>
          {s[field].length === 0 ? <p className="text-sm text-muted2">{slow ? "Tidak ada menu aktif." : "Belum ada menu terjual."}</p> : (
            <ol className="text-sm divide-y divide-sage-200">
              {s[field].map((it, i) => (
                <li key={it.menu_id} className="flex items-center gap-3 py-2" data-testid={`${slow ? "slow" : "top"}-item-${s.outlet_code}-${i + 1}`}>
                  <span className={`w-6 h-6 shrink-0 rounded-full grid place-items-center text-xs font-bold ${slow ? (it.qty === 0 ? "bg-red-50 text-red-700" : "bg-amber-50 text-amber-700") : i < 3 ? "bg-forest text-white" : "bg-sage-100 text-ink"}`}>{i + 1}</span>
                  <span className="flex-1 min-w-0 truncate">{it.name}</span>
                  <span className={`font-semibold whitespace-nowrap ${slow && it.qty === 0 ? "text-red-700" : ""}`}>{slow && it.qty === 0 ? "Belum terjual" : `${it.qty} terjual`}</span>
                  <span className="text-muted2 whitespace-nowrap hidden sm:inline w-28 text-right">{rupiah(it.revenue)}</span>
                </li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  </div>
);
